export default "__VITE_ASSET__e2d6170d__"